import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import Dialog from "../../../../components/Dialog";
import { IModalGenerateTach } from "../../Modal/Actions/ModalGenerateTach";
import ActionInformation from "./ActionInformation";
import HeaderInformation from "./HeaderInformation";
import JustifyInformation from "./JustifyInformation";
import TableInformation from "./TableInformation";
import UploadInformation from "./UploadInformation";
import AdminTachService from "../../../../service/Docente/AdminTachService";
import DialogMessageProps from "../../../../model/DialogMessageProps";
import { TypeDialogMessageEnum } from "../../../../model/Enums/TypeDialogMessageEnum";
import DialogMessage from "../../../../components/DialogMessage";
import GenericUtils from "../../../../utils/GenericUtils";
import { useAdministratorTach } from "../../../../context/AdministratorTachContext";
import { TermoHistorico } from "../../../../context/interfaces/IAdministratorTachContext";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";

interface IModalInformationContainer extends IModalGenerateTach {
    justify: boolean;
    subprocessId: string;
    status: string;
    historyTerm: TermoHistorico[];
    name: string;
    matriculaAdp: string;
}

interface IBodyUpload {
    fileName: string;
    justification: string;
}

const initialBodyUpload = {
    fileName: "",
    justification: "",
};

const ModalInformationContainer: React.FC<IModalInformationContainer> = ({
    isOpen,
    onHide,
    justify,
    subprocessId,
    status,
    historyTerm,
    name,
    matriculaAdp,
}) => {
    const [bodyUpload, setBodyUpload] =
        useState<IBodyUpload>(initialBodyUpload);
    const [isJustifyVisible, setIsJustifyVisible] = useState(false);
    const [dialogMessageProps, setDialogMessageProps] =
        useState<DialogMessageProps>({} as DialogMessageProps);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { instance } = useMsal();
    const { pagination, getSubprocessos } = useAdministratorTach();
    const { filterPage } = useFilterData();

    const handleChangeFileName = (fileName: string) => {
        setBodyUpload({
            ...bodyUpload,
            fileName,
        });
    };

    const handleChangeJustification = (justification: string) => {
        setBodyUpload({
            ...bodyUpload,
            justification,
        });
    };

    const isValidSendJustify = !!bodyUpload.justification.length && !isLoading;

    const handleCloseDialogMessage = () => {
        if (dialogMessageProps.type === TypeDialogMessageEnum.Success) {
            onHide();
            getSubprocessos(filterPage, pagination);
        }

        setDialogMessageProps({} as DialogMessageProps);
    };

    const handleJustifySubprocess = async () => {
        setIsLoading(true);

        if (bodyUpload.justification.length) {
            const response = await AdminTachService.justifySubprocess(
                subprocessId,
                bodyUpload.fileName || "",
                bodyUpload.justification,
                instance
            );

            if (GenericUtils.isSuccessStatus(response)) {
                setDialogMessageProps({
                    show: true,
                    type: TypeDialogMessageEnum.Success,
                    title: "Justificativa enviada!",
                    text: "A solicitação passará pela aprovação da coordenação.",
                });
            } else {
                setDialogMessageProps(
                    GenericUtils.getPropsDialogError(response)
                );
            }
        }

        setIsLoading(false);
    };

    const dialogMessage = dialogMessageProps.show && (
        <DialogMessage
            type={dialogMessageProps.type}
            show={dialogMessageProps.show}
            title={dialogMessageProps.title}
            text={dialogMessageProps.text}
            onClose={handleCloseDialogMessage}
        />
    );

    const showJustifyItems = (
        <>
            <JustifyInformation
                justification={bodyUpload.justification}
                setJustification={handleChangeJustification}
            />
            <UploadInformation
                setFileName={handleChangeFileName}
                subprocessId={subprocessId}
            />
        </>
    );

    return (
        <>
            <Dialog
                openModal={isOpen}
                onHide={() => onHide()}
                size="width-1200 modal-radius-8"
            >
                <HeaderInformation name={name} matriculaAdp={matriculaAdp} />
                <TableInformation historyTerm={historyTerm} />
                {!isJustifyVisible && justify && showJustifyItems}
                {isJustifyVisible && showJustifyItems}
                <ActionInformation
                    onHide={() => {
                        onHide();
                        setIsJustifyVisible(false);
                    }}
                    onMainActionClick={() => setIsJustifyVisible(true)}
                    showRightButton={justify}
                    isValidSendJustify={isValidSendJustify}
                    handleJustifySubprocess={handleJustifySubprocess}
                    status={status}
                />
            </Dialog>
            {dialogMessage}
        </>
    );
};

export default ModalInformationContainer;
